import { z } from "zod";
/**
 * O periodo do dashboard (spec 053, secao 3). O painel pede o mesmo periodo a cada dono do dado (o backend e o
 * `pagamentos`), e os dois precisam fazer a MESMA conta do periodo anterior e do agrupamento: senao a seta de um nao
 * bate com a do outro na mesma tela. Por isso mora no contrato.
 *
 * Dia e AAAA-MM-DD de Sao Paulo. A conta aqui e de calendario (sem fuso); o instante de cada dia sai de
 * `limitesDoPeriodo`, que sabe que Sao Paulo esta em -03:00 o ano todo (sem horario de verao desde 2019).
 */
export const MAXIMO_DE_DIAS_DAS_METRICAS = 400;
const meiaNoite = (dia) => new Date(`${dia}T00:00:00Z`);
export function somarDiasAoDia(dia, n) {
    const d = meiaNoite(dia);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
}
/** Quantos dias o periodo tem, contando o primeiro e o ultimo. */
export function diasNoPeriodo(p) {
    return Math.round((meiaNoite(p.ate).getTime() - meiaNoite(p.de).getTime()) / 86_400_000) + 1;
}
export const PeriodoDasMetricas = z
    .object({ de: z.string().date(), ate: z.string().date() })
    .refine((p) => p.de <= p.ate, { message: "o início vem antes do fim", path: ["ate"] })
    .refine((p) => diasNoPeriodo(p) <= MAXIMO_DE_DIAS_DAS_METRICAS, { message: `escolha até ${MAXIMO_DE_DIAS_DAS_METRICAS} dias`, path: ["de"] });
/** O periodo do mesmo tamanho logo antes (3.1): o mes atual ate o dia 16 compara com os 16 dias anteriores. */
export function periodoAnterior(p) {
    const n = diasNoPeriodo(p);
    return { de: somarDiasAoDia(p.de, -n), ate: somarDiasAoDia(p.de, -1) };
}
/** Ate dois meses o grafico vai por dia; mais que isso, por mes (365 pontos nao cabem numa linha que se le). */
export function agrupamentoDe(p) {
    return diasNoPeriodo(p) <= 62 ? "dia" : "mes";
}
/** As chaves do grafico em ordem e sem buraco: dia sem venda aparece com zero, nao some do eixo. */
export function chavesDoPeriodo(p, a = agrupamentoDe(p)) {
    const chaves = [];
    if (a === "dia") {
        for (let d = p.de; d <= p.ate; d = somarDiasAoDia(d, 1))
            chaves.push(d);
        return chaves;
    }
    for (let m = p.de.slice(0, 7); m <= p.ate.slice(0, 7); m = somarMeses(m, 1))
        chaves.push(m);
    return chaves;
}
/** "2026-10" mais n meses. */
export function somarMeses(mes, n) {
    const [ano, m] = mes.split("-").map(Number);
    const total = ano * 12 + (m - 1) + n;
    return `${Math.floor(total / 12)}-${String((total % 12) + 1).padStart(2, "0")}`;
}
/** Os ultimos `n` meses ate o de `hoje`, inclusive ("2025-11" ... "2026-10"). */
export function ultimosMeses(hoje, n = 12) {
    const atual = hoje.slice(0, 7);
    return Array.from({ length: n }, (_, i) => somarMeses(atual, i - n + 1));
}
/** Os instantes do periodo: do comeco do primeiro dia ao comeco do dia seguinte ao ultimo (exclusivo), em Sao Paulo. */
export function limitesDoPeriodo(p) {
    return { desde: new Date(`${p.de}T00:00:00-03:00`), antesDe: new Date(`${somarDiasAoDia(p.ate, 1)}T00:00:00-03:00`) };
}
//# sourceMappingURL=metricas.js.map